import {gql} from "@irati/utils/gql"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"

import wellnessMediaArticle from "../fragments/WellnessMediaArticle"

const query = gql`
  query WellnessMediaRentals($userId: ID!, $expiryStatus: ListMediaRentalsExpiryStatus!) {
    wellnessMediaRentals(userId: $userId, expiryStatus: $expiryStatus) {
      results {
        uuid
        userId
        mediaId
        expiresAt
        mediaType
        media {
          ...wellnessMediaArticle
        }
      }
    }
  }
  ${wellnessMediaArticle}
`
export const wellnessMediaRentalsKey = getQueryNames(query)[0]

export default query
